<template>
    <div class="requisition-assignments" v-if="display">
        <template v-if="requisition">
            <table class="trade">
                <thead>
                    <tr>
                        <td>Trades Requested:</td>
                        <td>Shift</td>
                        <td>Specific Date</td>
                        <td>Quantity</td>
                        <td>Assigned</td>
                        <td>Sub Rate</td>
                        <td>Sub Rule</td>
                        <td></td>
                    </tr>
                </thead>

                <template v-for="(request, i) in requisition.jobRequests">
                <tbody>
                    <tr>
                        <td>{{ request.name }}</td>
                        <td>{{ request.date.name }}</td>
                        <td>{{ request.specific_date ? "Yes":"No" }}</td>
                        <td>{{ request.quantity }}</td>
                        <td>{{ request.placements.length }}</td>
                        <td>{{ request.sub_rate }}</td>
                        <td>{{ request.per_diem_type }}</td>
                        <td >
							<span v-if="!hasNote(request, i)" class="job-note-icon" @click="loadNotes(request, i)">
								<img src="/images/note_empty.svg"/>
							</span>
							<span v-if="hasNote(request, i)" class="job-note-icon active" @click="loadNotes(request, i)">
								<svg xmlns="http://www.w3.org/2000/svg" width="21.733" height="23.954" viewBox="0 0 21.733 23.954">
								  <g id="Group_1516" data-name="Group 1516" transform="translate(-1332 -1381.001)">
									<path id="Path_109" data-name="Path 109" d="M197.127,358.066c-.021,0-.041.008-.062.009a1.557,1.557,0,0,1,.579.078A1.6,1.6,0,0,0,197.127,358.066Z" transform="translate(1155.055 1027.863)" fill="#004993"/>
									<path id="Path_110" data-name="Path 110" d="M197.062,358.088a1.506,1.506,0,0,0-.266.044l.017.021A1.692,1.692,0,0,1,197.062,358.088Z" transform="translate(1154.899 1027.876)" fill="#004993"/>
									<path id="Path_111" data-name="Path 111" d="M197.664,375.746c.3-.406,1.089-1.2,2.775-3.138.645-.742.489-.595,2.786-7.215l0,0c1.714-4.949,1.741-4.954,1.741-5.254h0a1.522,1.522,0,0,0-2.013-1.63l-.017-.021a1.576,1.576,0,0,0-1.006.982,2.17,2.17,0,0,1,.209-1.679c-.768-.417-.157-.294-13.526-.294a2.365,2.365,0,0,0-2.372,2.356v15.226a2.365,2.365,0,0,0,2.372,2.356H201.02a2.362,2.362,0,0,0,2.356-2.356v-3.259C202.263,372.823,199.33,375.294,197.664,375.746Zm-7.2-2.274a.791.791,0,1,1,0-1.581h7.5l.12,1.581Zm7.855-3.6h-7.855a.791.791,0,1,1,0-1.581h8.4Zm1.246-3.6h-9.1a.791.791,0,1,1,0-1.581c7.226,0,9.393-.006,9.645.008Zm-9.891-4.386a.79.79,0,0,1,.791-.791h8.682a.791.791,0,1,1,0,1.581h-8.682A.79.79,0,0,1,189.678,361.9Z" transform="translate(1148.763 1027.521)" />
    								<circle id="Ellipse_1" data-name="Ellipse 1" cx="5" cy="5" r="5" transform="translate(1332 1381.001)" fill="#31a848"/>
								  </g>
								</svg>
							</span>
                            <span :uk-toggle="'target: #placement-list-' + i + '; animation: uk-animation-scale-up'" @click="requestToggled(request)">
                                <i class="fas fa-sort-down uk-margin-small-right" :class="{'closed':!requestExpanded(request)}"></i>
                                {{ !requestExpanded(request) ? "Show Assignments":"Hide Assignments" }}
                            </span>
                            <button v-if="request.quantity > 2" class="uk-button-small primary" :uk-toggle="'target: #' + assignmentModalId" @click="placeMultiple(request)">Bulk Add</button>
                        </td>
                    </tr>
                    <tr :id="'placement-list-' + i" class="placement" :class="{specific:request.specific_date}">
                        <td colspan="8">
                            <table>
                                <thead>
                                    <tr>
                                        <td>Worker</td>
                                        <td>Shift</td>
                                        <td></td>
                                        <td>Craft Code</td>
                                        <td>Travel In</td>
                                        <td>Travel Out</td>
                                        <td>Sub Rate</td>
                                        <td>Start Date</td>
                                        <td>End Date</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(placement, j) in requestList(request)" class="placement-row" :class="{noshow:placement.hasNoShows,attendance:placement.attendance_danger,dropped: placement.dropped, deleting: placement.deleting}">
                                        <template v-if="placement.person.id">
											<td><a :href="'/employees/view/' + placement.person.id" target="_blank">{{ placement.person.full_name }}</a></td>
                                            <td>{{ request.date.name }}</td>
                                            <td>
                                                <a :href="'/employees/view/' + placement.person.id" target="_blank"><i class="fas fa-search is-clickable"></i></a>
												<i class="fas fa-star primary-color is-clickable" @click="startRating(placement.id)"></i>
                                                <i class="fas fa-ban primary-color is-clickable" @click="displayNoShowOptions(placement)"></i>
                                                <i class="fas fa-window-close primary-color is-clickable" @click="dropPlacement(placement)"></i>
                                                <i class="fas fa-trash primary-color is-clickable" @click="removePlacement(placement)"></i>
                                                <i class="fas fa-question primary-color is-clickable" @click="displayHelp"></i>
                                            </td>
                                            <td><span v-if="!placement.editingPayCode">{{ placement.payCode ? placement.payCode.code:"" }}</span>
                                                <button v-if="!placement.editingPayCode" class="uk-button-small primary" @click="editPayCode(placement)"><i class="fas fa-pencil-alt"></i></button>
                                                <select v-if="placement.editingPayCode" class="uk-select" v-model="placement.payCode.id" @change="changeCraftCode(placement)">
                                                    <option v-for="payCode in request.payCodes" :value="payCode.id">{{ payCode.code }}</option>
                                                </select>
                                            </td>
                                            <td><input class="uk-input telling-field" type="number" style="text-align: right;"
                                                       :class="{edited:placement.dirtyTravelIn, saving:placement.savingTravelIn}"
                                                       @change="markDirtyTI(placement)" @keyup.enter="changeTravelIn(placement)"
                                                       @keydown.tab="changeTravelIn(placement)" @keydown="markDirtyTI(placement)"
                                                       v-model="placement.travel_in"
                                            /></td>
                                            <td><input class="uk-input telling-field" type="number" style="text-align: right;"
                                                       :class="{edited:placement.dirtyTravelOut, saving:placement.savingTravelOut}"
                                                       @change="markDirtyTO(placement)" @keyup.enter="changeTravelOut(placement)"
                                                       @keydown.tab="changeTravelOut(placement)" @keydown="markDirtyTO(placement)"
                                                       v-model="placement.travel_out"
                                            /></td>
                                            <td><input class="uk-input telling-field" type="number" style="text-align: right;"
                                                       :class="{edited:placement.dirtySub, saving:placement.savingSub}"
                                                       @change="markDirtySub(placement)" @keyup.enter="changeSubRate(placement)"
                                                       @keydown.tab="changeSubRate(placement)" @keydown="markDirtySub(placement)"
                                                       v-model="placement.sub_rate"
                                            /></td>
                                            <td><datepicker :id="'placement_start_date' + placement.id" name="shift_end_date[]" @input="changeStartDate" @selected="selectPlacement(placement)"
                                                            :value="placement.start_date" input-class="uk-input" :use-utc=true :typeable=true
                                                            format="MM/dd/yyyy"></datepicker></td>
                                            <td><datepicker :id="'placement_end_date' + placement.id" name="shift_end_date[]" @input="changeEndDate" @selected="selectPlacement(placement)"
                                                            :value="placement.end_date" input-class="uk-input" :use-utc=true :typeable=true
                                                            format="MM/dd/yyyy"></datepicker></td>
                                            <td><i v-if="placement.notes != ''" :title="placement.notes" class="fas fa-exclamation-triangle primary-color"></i></td>
                                        </template>
                                        <template v-if="!placement.person.id">
                                            <td>-</td>
                                            <td>{{ request.date.name }}</td>
                                            <td><button class="uk-button-small primary" :uk-toggle="'target: #' + assignmentModalId" @click="placeSingle(request)">Add</button></td>
                                            <td>(Add worker first)</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td><i class="fas fa-times-circle" @click="dropRow(request)"></i></td>
                                        </template>
                                    </tr>
                                    <tr>
                                        <td style="background: #ffffff;" colspan="10"><i class="fas fa-plus-circle" @click="addRow(request)"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </template>
				<tbody v-if="unplacedPeople.length > 0">
				<tr>
					<td>Unplaced from Time Records</td>
					<td></td>
					<td></td>
					<td></td>
					<td>{{ unplacedPeople.length }}</td>
					<td></td>
					<td></td>
					<td >

					</td>
				</tr>
				<tr class="placement">
					<td colspan="8">
						<table>
							<thead>
							<tr>
								<td>Worker</td>
								<td>Shift</td>
								<td>Start Date</td>
								<td>End Date</td>
								<td></td>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(placement) in unplacedPeople" class="placement-row" :class="{noshow:placement.hasNoShows,attendance:placement.attendance_danger,dropped: placement.dropped, deleting: placement.deleting}">
								<template v-if="placement.person.id">
									<td><a :href="'/employees/view/' + placement.person.id" target="_blank">{{ placement.person.full_name }}</a></td>
									<td>
										<select class="uk-select" :key="'plc_' + placement.id" @change.prevent="setJob($event, placement.id)">
											<option value="">SELECT POSITION</option>
											<option v-for="position in requisition.jobRequests" :value="position.id">{{ position.name }} ({{ position.shift.name }})</option>
										</select>
									</td>
									<td>{{ placement.start_date }}</td>
									<td>{{ placement.end_date }}</td>
									<td></td>
								</template>
							</tr>
							</tbody>
						</table>
					</td>
				</tr>
				</tbody>
            </table>
        </template>
        <div id="noshow-modal" ref="noshow-modal" uk-modal>
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title">Mark as No-Show</h2>
                <div class="list-labels">
                    <label>
                        <input class="uk-radio" type="radio" name="noshow_type" value="today" v-model="noshowType"/> Just Today
                    </label>
                    <label>
                        <input class="uk-radio" type="radio" name="noshow_type" value="whole_job" v-model="noshowType"/> Entire Job
                    </label>
                    <label>
                        <input class="uk-radio" type="radio" name="noshow_type" value="range" v-model="noshowType"/> Date Range
                    </label>
                    <div v-if="noshowType == 'range'">
                        <label style="width: 48%;">
                            From:
                            <datepicker id="noshow_start_date" @input="changeNoshowStart"
                                        :value="noshowStart" input-class="uk-input" :use-utc=true :typeable=true
                                        format="MM/dd/yyyy"></datepicker>
                        </label>
                        <label style="width: 48%;">
                            To:
                            <datepicker id="noshow_end_date"  @input="changeNoshowEnd"
                                        :value="noshowEnd" input-class="uk-input" :use-utc=true :typeable=true
                                        format="MM/dd/yyyy"></datepicker>
                        </label>
                    </div>
                    <label>
                        <input class="uk-checkbox" type="checkbox" value="1" v-model="addProbation"/> Place on Probation
                    </label>
                    <label v-if="addProbation" style="width: 48%">
                        Until:
                        <datepicker id="probation_date" @input="changeProbation"
                                    :value="probationEnd" input-class="uk-input" :use-utc=true :typeable=true
                                    format="MM/dd/yyyy"></datepicker>
                    </label>

                </div>
                <div class="uk-margin-medium-bottom"></div>
                <button class="uk-button uk-button-primary uk-modal-close" type="button" uk-toggle="target: #noshow-modal" @click="markNoShow">Mark No-Show</button>
                <button class="uk-button uk-button-tertiary uk-modal-close" type="button">Cancel</button>
            </div>
        </div>
        <div id="help_modal" ref="help-modal" uk-modal>
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title">Help</h2>
                <div>
                    <p><i class="fas fa-search primary-color"></i> - Display the employee information in a new tab.</p>
                </div>
                <div>
                    <p><i class="fas fa-star primary-color"></i> - Open dialogue to rate this employee at this job.</p>
                </div>
                <div>
                    <p><i class="fas fa-ban primary-color"></i> - Mark the employee as a no-show.
                    This will bring up a menu with additional options.</p>
                </div>
                <div>
                    <p><i class="fas fa-window-close primary-color"></i> - Drops the employee from the project.
                    If the project hasn't started yet or the employee was added very recently, this will have the same effect as deleting them.
                    Otherwise, it will set their last day to today and mark them as dropped. Last day can be adjusted after. Use this
                    when the employee left the job early.</p>
                </div>
                <div>
                    <p><i class="fas fa-trash primary-color"></i> - Deletes the employee from the project. The system will behave as though
                    they were never added.</p>
                </div>
                <div>
                    <p><i class="fas fa-question primary-color"></i> - Brings up this box.</p>
                </div>
                <div class="uk-margin-medium-bottom"></div>
                <button class="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
            </div>
        </div>
		<div id="ratingModal" uk-modal>
			<rating-form ref="ratingForm" table="currentPlacements" @complete="closeForm"></rating-form>
		</div>
    </div>
</template>

<script>
	import Format from "../Classes/Format";
	import Datepicker from "vuejs-datepicker";
	import RatingForm from "./ModalForms/RatingForm.vue";
    export default {
        name: "RequisitionAssignments",
		components:{
			RatingForm,
			Datepicker
		},
        props:{
            rid: Number,
            assignmentModalId:String,
            assignmentRef:String,
            messageFormRef:String,
			display:{type:Boolean, default:true},
			nid: {type:String, default:null} //Note box ID
        },

        data(){
            return {
                requisition:null,
                placer:null,
                messager:null,
                expandedRequests:[],
                selectedPlacement:null,
                noteCaches: [],
                noshowType: "today",
                noshowPlacement: null,
                noshowStart: null,
                noshowEnd: null,
                addProbation: true,
                probationEnd: null,
				unplacedPeople: []
            };
        },

        mounted(){
            this.loadRequisition();
        },
        methods: {
            loadRequisition() {
                axios.get("/api/requisition/get/" + this.rid)
                    .then((pack) => this.updateRequisitionData(pack));
            },
            updateRequisitionData(pack) {
                if (pack.data.success) {
                    this.requisition = pack.data.data;
                }
                this.placer = this.$root.$refs[this.assignmentRef]; //page loaded when request returned
                this.messager = this.$root.$refs[this.messageFormRef];
                this.messager ? this.updateMessages():null;

                for(let i = 0; i < this.requisition.jobRequests.length;++i){
                    this.expandedRequests.push(this.requisition.jobRequests[i].id);
                }
            },
            updateMessages(){
                let availablePlacements = 0;
                let setPlacements = 0;
                let personIds = [];

                for(let j = 0; j < this.requisition.jobRequests.length;++j){
                    let request = this.requisition.jobRequests[j];
                    if(!request.totalRows){
                        request.totalRows = request.quantity;
                    }
                    this.loadPlacements(request.id);
                    for(let i = 0; i < request.totalRows || i < request.placements.length;++i){
                        if(i < request.totalRows){
                            availablePlacements++;
                        }
                        if(i < request.placements.length){
                            setPlacements++;
                            //personIds.push(request.placements[i].person.id);
                        }
                    }

                    if(this.requisition.manager && this.requisition.manager.person){
                        personIds.push(this.requisition.manager.person.id);
                    }
                    if(this.requisition.contact && this.requisition.contact.person){
                        personIds.push(this.requisition.contact.person.id);
                    }
                }
				this.loadUnplaced();

                this.messager.setRequisition(this.requisition);
                this.messager.displayWarning = setPlacements < availablePlacements;
            },
			loadPlacements(jobId){
				axios.get("/api/requisition/placements/"+jobId).then(
					ax => this.updateLoadedPlacements(ax, jobId),
					ax => this.updateLoadedPlacements(ax, false)
				);
			},
			loadUnplaced(){
				axios.get("/api/requisition/nonplacements/" + this.rid).then(
					ax => this.updateLoadedNonPlacements(ax),
					ax => this.updateLoadedNonPlacements(ax)
				);
			},
			updateLoadedPlacements(pack, jobId){
				if(pack.data.success && jobId){
					let placements = pack.data.data;
                    for(let j = 0; j < this.requisition.jobRequests.length;++j){
                        if(this.requisition.jobRequests[j].id == jobId){
                            this.requisition.jobRequests[j].placements = placements;
                            return;
                        }
                    }
				}
			},
			updateLoadedNonPlacements(pack){
				if(pack.data.success){
					this.unplacedPeople = pack.data.data;
				}
			},
			setJob(ev, placementId){
				if(ev.target.value == ""){
					return;
				}
				axios.post("/api/requisition/set_placement", {
					job_request_id: ev.target.value,
					placement_id: placementId
				}).then(
					() => this.setJobDone(),
					() => this.setJobDone(),
				);
			},
			setJobDone(){
				this.updateMessages();
			},
            requestList(request){
                let ret = [];
                if(!request.totalRows){
                    request.totalRows = request.quantity;
                }
                for(let i = 0; i < request.totalRows || i < request.placements.length;++i){
                    if(i < request.placements.length){
                        ret.push(request.placements[i]);
                    } else {
                        ret.push({
                            person:{full_name:"-"},
                            payCode:{code:""},
                            travel_in:0,
                            travel_out:0,
                            start_date:null,
                            end_date:null,
                            notes:""
                        })
                    }

                }
                return ret;
            },
            requestToggled(request){
                if(this.expandedRequests.indexOf(request.id) < 0){
                    this.expandedRequests.push(request.id);
                } else {
                    this.expandedRequests.splice(this.expandedRequests.indexOf(request.id), 1);
                }
            },
            requestExpanded(request){
                return this.expandedRequests.indexOf(request.id) > -1;
            },
            placeSingle(request){
                this.placer.placeSingle(request.id);
            },
            placeMultiple(request){
                this.placer.placeMultiple(request.id);
            },
            removePlacement(placement){
                placement.deleting = true;
                this.$forceUpdate();
                axios.post("/api/requisition/remove/placement", {pid:placement.id})
                    .then(() => this.placementRemoved(placement));
            },
            placementRemoved(placement){
                let jobRequest = this.getJobById(placement.job_request_id);
                for(let i = 0; i < jobRequest.placements.length;++i){
                    if(jobRequest.placements[i].id == placement.id){
                        jobRequest.placements.splice(i, 1);
                        break;
                    }
                }
            },
            dropPlacement(placement){
                placement.deleting = true;
                this.$forceUpdate();
                axios.post("/api/requisition/drop/placement", {pid:placement.id})
                    .then(() => this.placementDropped(placement));
            },
            placementDropped(placement){
                this.loadPlacements(placement.job_request_id);
            },
            displayNoShowOptions(placement){
                this.noshowPlacement = placement;
                this.noshowType = "today";
                this.noshowStart = placement.start_date;
                this.noshowEnd = placement.end_date;
                let defaultProbation = new Date();
                defaultProbation.setDate(defaultProbation.getDate()+14);
                this.changeProbation(defaultProbation);
                UIkit.modal(this.$refs["noshow-modal"]).show();
            },
            markNoShow(){
                let placement = {...this.noshowPlacement};
                axios.post("/api/requisition/noshow/placement", {
                    pid:placement.id,
                    noshowType: this.noshowType,
                    noshowStart: this.noshowStart,
                    noshowEnd: this.noshowEnd,
                    addProbation: this.addProbation,
                    probationEnd: this.probationEnd
                })
                    .then(() => this.noshowMarked(placement));
            },
            noshowMarked(placement){
                this.loadPlacements(placement.job_request_id);
            },
            displayHelp(){
                UIkit.modal(this.$refs["help-modal"]).show();
            },
            editPayCode(placement){
                placement.editingPayCode = true;
                this.$forceUpdate();
            },
            changeCraftCode(placement){
                axios.post("/api/requisition/update-code/" + placement.id, {pay_code_id:placement.payCode.id})
                    .then((pack, placement) => this.updatePlacement(pack, placement));
            },
            selectPlacement(placement){
                this.selectedPlacement = placement;
            },
            changeStartDate(val){
                this.selectedPlacement.start_date = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
                this.updateDates(this.selectedPlacement);
            },
            changeEndDate(val){
                this.selectedPlacement.end_date = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
                this.updateDates(this.selectedPlacement);
            },
            changeNoshowStart(val){
                this.noshowStart = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            changeNoshowEnd(val){
                this.noshowEnd = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            changeProbation(val){
                this.probationEnd = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            markDirtyTI(placement){
                if(!placement.dirtyTravelIn){
                    placement.dirtyTravelIn = true;
                    this.$forceUpdate();
                }
            },
            markDirtyTO(placement){
                if(!placement.dirtyTravelOut){
                    placement.dirtyTravelOut = true;
                    this.$forceUpdate();
                }
            },
            markDirtySub(placement){
                if(!placement.dirtySub){
                    placement.dirtySub = true;
                    this.$forceUpdate();
                }
            },
            changeSubRate(placement){
                placement.dirtySub = false;
                placement.savingSub = true;
                this.$forceUpdate();
                axios.post("/api/requisition/update-sub/" + placement.id,
                    {sub_rate:placement.sub_rate})
                    .then((pack) => this.clearSubRate(placement, pack),
                        () => this.subRateFailure(placement)
                    );
            },
            changeTravelIn(placement){
                placement.dirtyTravelIn = false;
                placement.savingTravelIn = true;
                this.$forceUpdate();
                axios.post("/api/requisition/update-ti/" + placement.id,
                    {travel_in:placement.travel_in})
                    .then((pack) => this.clearTravelIn(placement, pack),
                        () => this.tiFailure(placement)
                    );
            },
            changeTravelOut(placement){
                placement.dirtyTravelOut = false;
                placement.savingTravelOut = true;
                this.$forceUpdate();
                axios.post("/api/requisition/update-to/" + placement.id,
                    {travel_out:placement.travel_out})
                    .then((pack) => this.clearTravelOut(placement, pack),
                        () => this.toFailure(placement)
                    );
            },
            clearSubRate(placement, pack){
                if(pack.data.success){
                    placement.dirtySub = false;
                    placement.savingSub = false;
                    this.$forceUpdate();
                } else {
                    this.subRateFailure();
                }
            },
            clearTravelIn(placement, pack){
                if(pack.data.success){
                    placement.dirtyTravelIn = false;
                    placement.savingTravelIn = false;
                    this.$forceUpdate();
                } else {
                    this.tiFailure();
                }
            },
            clearTravelOut(placement, pack){
                if(pack.data.success){
                    placement.dirtyTravelOut = false;
                    placement.savingTravelOut = false;
                    this.$forceUpdate();
                } else {
                    this.toFailure();
                }
            },
            subRateFailure(placement){
                placement.dirtySub = true;
                placement.savingSub = false;
                this.$forceUpdate();
            },
            tiFailure(placement){
                placement.dirtyTravelIn = true;
                placement.savingTravelIn = false;
                this.$forceUpdate();
            },
            toFailure(placement){
                placement.dirtyTravelOut = true;
                placement.savingTravelOut = false;
                this.$forceUpdate();
            },
            updateDates(placement){
                axios.post("/api/requisition/update-dates/" + placement.id,
                    {start_date:placement.start_date, end_date:placement.end_date})
                    .then((pack) => this.updatePlacement(pack));
            },
            updatePlacement(pack){
                if(pack.data.success){
                    this.loadPlacements(pack.data.data.job_request_id);
                }
            },
            appendPlacements(jobId, newPlacements){
                let jobRequest = this.getJobById(jobId);
                for(let i = 0; i < newPlacements.length;++i){
                    jobRequest.placements.push(newPlacements[i]);
                }
            },
			fDate(dt){
				return Format.formatDate(dt);
			},
			getJobById(id){
				for(let i = 0; i < this.requisition.jobRequests.length;++i){
					if(this.requisition.jobRequests[i].id == id){
						return this.requisition.jobRequests[i];
					}
				}

				return null;
			},
			loadNotes(craft, index){
				let notes = "";
				if(craft.notes && craft.notes.length > 0){
					notes = craft.notes[0].content;
				} else { //check note cache for existing note
					for(let i = 0; i < this.noteCaches.length;++i){
						if(this.noteCaches[i].index == index){
							notes = this.noteCaches[i].content;
							break;
						}
					}
				}
				this.$root.$refs[this.nid].loadNotes(notes, craft.id, index, this);
			},
			cacheBack(note, index){
            	let found = false;
				for(let i = 0; i < this.noteCaches.length;++i){
					if(this.noteCaches[i].index == index){
						this.noteCaches[i].content = note;
						found = true;
						break;
					}
				}
				if(!found){
					this.noteCaches.push({
						index: index,
						content: note
					});
				}

			},
			updateItem(note, jobId){
				let craft = this.getJobById(jobId);
				if(craft.notes.length < 1){
					craft.notes.push({
						content: note
					});
				} else {
					craft.notes[0].content = note;
				}
			},
			hasNote(craft, index){
				if(craft.notes && craft.notes.length > 0){
					return true;
				} else {
					for(let i = 0; i < this.noteCaches.length;++i){
						if(this.noteCaches[i].index == index){
							return true;
						}
					}
				}

				return false;
			},
            dropRow(request){
                request.totalRows--;
                this.$forceUpdate();
            },
            addRow(request){
                request.totalRows++;
                this.$forceUpdate();
            },
			startRating(id){
				this.$refs.ratingForm.loadForm(id);
				UIkit.modal("#ratingModal").show();
			},
			closeForm(){
				UIkit.modal("#ratingModal").hide();
				setTimeout(() => this.startSearch(), 500);
			}
        },
		watch: {
			requisition: {
				handler: function (val) {
					//hopefully the function just has to exist :P
				},
				deep: true
			}
		}
    }
</script>
